import React from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../context/auth-context";
import ReferAndEarnContent from "./ReferAndEarnContent";

// Mounted only under AdminLayout, so useAuth() is always safe here.
const AdminReferAndEarn = () => {
  const { workerType } = useParams();
  const { token } = useAuth();

  return <ReferAndEarnContent token={token} workerType={workerType} />;
};

export default AdminReferAndEarn;